/**
 * 园区纯逻辑（无 React / 无 DB / 无 DOM 字符串）
 * 说明：卡片与区块已改为真正的 JSX 组件（见 app/[[...slug]]/components），
 * 这里仅保留位置文案等纯工具函数供组件复用。
 */
import type {ParkItem} from '@/common/interface/park';

/** 「城市 · 区县」定位行文案 */
export function locLine(p: ParkItem): string {
    return [p.city, p.district].filter(Boolean).join(' · ');
}
